import { render, staticRenderFns } from "./DepositSubmission.vue?vue&type=template&id=904380a2&scoped=true"
import script from "./DepositSubmission.vue?vue&type=script&lang=js"
export * from "./DepositSubmission.vue?vue&type=script&lang=js"
import style0 from "./DepositSubmission.vue?vue&type=style&index=0&id=904380a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904380a2",
  null
  
)

export default component.exports